export const APP_BECAME_VISIBLE = 'APP_BECAME_VISIBLE';
export const APP_BECAME_HIDDEN = 'APP_BECAME_HIDDEN';
